export default __webpack_public_path__ + "static/media/redux.7ea723c9.png";